import { render, staticRenderFns } from "./YKUseCase.vue?vue&type=template&id=78e51526&scoped=true&"
import script from "./YKUseCase.vue?vue&type=script&lang=js&"
export * from "./YKUseCase.vue?vue&type=script&lang=js&"
import style0 from "./YKUseCase.vue?vue&type=style&index=0&id=78e51526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e51526",
  null
  
)

export default component.exports